import { type CAPITAL_PARTNER_NETWORK_CONTENT } from '../content';
import {
  ActionRow,
  ContentContainer,
  HeroBody,
  HeroEyebrow,
  HeroSectionShell,
  HeroStack,
  HeroTitle,
  PrimaryAction,
} from '../styles';

type HeroCopy = (typeof CAPITAL_PARTNER_NETWORK_CONTENT)['hero'];

type HeroSectionProps = {
  copy: HeroCopy;
};

export default function HeroSection({ copy }: HeroSectionProps) {
  return (
    <HeroSectionShell>
      <ContentContainer>
        <HeroStack>
          <HeroEyebrow>{copy.eyebrow}</HeroEyebrow>
          <HeroTitle>{copy.title}</HeroTitle>
          <HeroBody>{copy.subheadline}</HeroBody>
          <ActionRow>
            <PrimaryAction href={copy.primaryCta.href}>{copy.primaryCta.label}</PrimaryAction>
          </ActionRow>
        </HeroStack>
      </ContentContainer>
    </HeroSectionShell>
  );
}
